export function bannerWithAnimation() {
    const $window = $(window);
    let $bannerSection = $(".banner-with-animation");

    function bannerAnimation() {
        let winTop = $window.scrollTop();
        $bannerSection.each(function () {
            let $this = $(this);
            let windowHeight = $window.innerHeight();
            let sectionHeight = $this.innerHeight();
            let sectionTop = $this.offset().top;
            if ($this.hasClass("two-steps")) {
                if (winTop > sectionTop + (sectionHeight - windowHeight) / 2) {
                    $this.addClass("second-step");
                } else {
                    $this.removeClass("second-step");
                }
            }
            if ($this.hasClass("three-steps")) {
                if (winTop > sectionTop + (sectionHeight - windowHeight) / 3) {
                    $this.addClass("second-step");
                } else {
                    $this.removeClass("second-step");
                }
                if (winTop > sectionTop + (sectionHeight - windowHeight) / 1.5) {
                    $this.addClass("third-step");
                } else {
                    $this.removeClass("third-step");
                }
                if ($this.prev().find(".how-works-block.with-animation").length) {
                    let offsetIndent = windowHeight * 0.1845;
                    let card = $this.prev().find(".how-works-block .item:first-child");
                    let gradientCard = $this.find(".gradient-card:first-child");
                    let cardTop = card.offset().top;
                    let cardLeft = card.offset().left;
                    let cardCssLeft = card.css("left");
                    let cardMarginLeft = card.css("margin-left");
                    let gradientCardTop = sectionTop + offsetIndent;
                    gradientCard.addClass("ready-for-animation").css({
                        // "transform": "translateY(" + (cardTop - gradientCardTop) + "px)",
                        "margin-top": cardTop - gradientCardTop,
                        "height": card.innerHeight(),
                        "width": card.innerWidth(),
                        "z-index": -1
                    });
                    if (winTop > cardTop - offsetIndent) {
                        gradientCard.css({
                            // "transform": "translate3d(0," + ((cardTop - gradientCardTop) + (winTop - (cardTop - offsetIndent))) + "px,0)",
                            "position": "fixed",
                            "margin": "0",
                            "top": offsetIndent,
                            "left": cardLeft,
                            "display": "block"
                        });
                        card.css("opacity", 0);
                    } else {
                        gradientCard.css({
                            // "transform": "translate3d(0," + (cardTop - gradientCardTop) + "px,0)",
                            "position": "absolute",
                            "left": cardCssLeft,
                            "margin-left": cardMarginLeft,
                            "display": "none"
                        });
                        card.css("opacity", 1);
                    }
                    if (winTop > sectionTop) {
                        gradientCard.addClass("sticky").css({
                            // "transform": "translate3d(0, 0, 0)",
                            "position": "absolute",
                            "left": cardCssLeft,
                            "margin-left": cardMarginLeft
                        });
                    } else {
                        gradientCard.removeClass("sticky");
                    }
                }
            }
        });
    }

    $window.on("load scroll", function () {
        bannerAnimation();
    });
    $window.on("orientationchange", function () {
        setTimeout(function () {
            bannerAnimation();
        }, 300);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/bannerWithAnimation.js